import * as React from 'react';
import { Icons } from '../icons';
export var EntityTypeIconsSetDefault = Icons.Entities;
export var EntityTypeIconsContext = React.createContext(Icons.Entities);
export var EntityTypeIconsProvider = EntityTypeIconsContext.Provider;